// AppContext.js (สร้าง Context)
import React from 'react';

// สร้าง Context object
const AppContext = React.createContext("");

export default AppContext;